import { TestIdClassNameProps } from "@app/types/Common";
import { Field } from "@app/types/Cue";
import { Name } from "@app/types/enums";
import { getFieldValue } from "@util/helpers";

export type PullQuoteProps = TestIdClassNameProps & {
  fields: Field[];
  annotation: string;
};

export default function PullQuote({
  testId,
  rootClassName,
  fields,
  annotation,
}: PullQuoteProps): React.ReactElement {
  const label = getFieldValue(fields, Name.QuoteLabel);
  const quote = getFieldValue(fields, Name.Quote);
  const quotee = getFieldValue(fields, Name.Quotee);
  const credit = getFieldValue(fields, Name.QuoteCredit);
  const excludeForBT = getFieldValue(fields, Name.QuoteRule);

  return (
    <div
      data-annotation={annotation}
      data-testid={testId}
      className={rootClassName}
    >
      {label && excludeForBT === "false" ? (
        <div
          className="mb-4 font-poppins text-base font-normal uppercase"
          data-testid={testId ? `${testId}-label` : undefined}
        >
          {label}
        </div>
      ) : null}

      {quote ? (
        <blockquote
          className="mb-4 font-lct text-8xl text-black"
          data-testid={testId ? `${testId}-quote` : undefined}
        >
          {quote}
        </blockquote>
      ) : null}

      {quotee ? (
        <div
          className="font-poppins text-base font-normal text-gray-515"
          data-testid={testId ? `${testId}-quotee` : undefined}
        >
          {quotee}
        </div>
      ) : null}

      {credit && excludeForBT === "false" ? (
        <div
          className="font-poppins text-base font-normal text-gray-515"
          data-testid={testId ? `${testId}-credit` : undefined}
        >
          {credit}
        </div>
      ) : null}

      <div
        className="h-[73px] font-pullQuote text-[140px] font-normal leading-none text-gray-475"
        data-testid={testId ? `${testId}-icon` : undefined}
      >
        ”
      </div>
    </div>
  );
}
